import { render, staticRenderFns } from "./SettingExplain.vue?vue&type=template&id=923f80b6&scoped=true"
import script from "./SettingExplain.vue?vue&type=script&lang=js"
export * from "./SettingExplain.vue?vue&type=script&lang=js"
import style0 from "./SettingExplain.vue?vue&type=style&index=0&id=923f80b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923f80b6",
  null
  
)

export default component.exports